/**
 * Created by zhaoyue on 16/11/28.
 */
import { QuerySelect } from 'ekbc-query-builder'
import { app as api } from '@ekuaibao/whispered'
import key from './key'
import { Resource } from '@ekuaibao/fetch'
const flows = new Resource('/api/flow/v1/flows')
import parseQuery2Select from '@ekuaibao/lib/lib/parseQuery2Select'
import parseSelectUsePropertySet from '@ekuaibao/lib/lib/parseSelectUsePropertySet'
import { getBacklogInfoById } from '../expense-manage-action'

function getPropertySet() {
  return api.dataLoader('@common.globalFields').load()
}

//获取激活流程
export function getSearchFlow(params, scene, dimensionItems, privilegeId) {
  const filtersFixer = api.require('@lib/filtersFixer')
  let { status, otherFilters = [] } = params
  status = {
    state: [
      'archived',
      'paid',
      'paying',
      'approving',
      'sending',
      'receiving',
      'receivingExcep',
      'rejected',
      'nullify'
    ],
    ...status
  }
  params = { ...params, status }
  let query = parseQuery2Select(params, undefined, 'flow')
  if (otherFilters.length) {
    otherFilters.forEach((filter) => {
      query = query.filterBy(filter)
    })
  }
  return {
    type: key.GET_SEARCH_FLOW,
    payload: getPropertySet().then((resp) => {
      const content = parseSelectUsePropertySet(resp.data)
      const sceneFiltersQuery = scene ? filtersFixer(scene, 'flow', dimensionItems) : ''
      query.select(`ownerId(id,name),form(${content},...),...`).filterBy(sceneFiltersQuery)
      const queryString = query.value()
      return flows.POST(
        '/search',
        queryString,
        privilegeId
          ? {
            privilegeId,
            join: 'id,nodeState,/flow/v2/backlogs/state'
          }
          : {
            formType: 'receipt',
            join: 'id,nodeState,/flow/v2/backlogs/state'
          }
      )
    })
  }
}

//获取审批流程详情
export { getBacklogInfoById }